var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCandadoGris = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.171,
    height: 26.895,
    viewBox: "0 0 20.171 26.895",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "candado",
    d: "M20.65,10.085h-.84V6.724a6.724,6.724,0,1,0-13.447,0v3.362h-.84A2.524,2.524,0,0,0,3,12.607V24.373a2.524,2.524,0,0,0,2.521,2.521H20.65a2.524,2.524,0,0,0,2.521-2.521V12.607A2.524,2.524,0,0,0,20.65,10.085ZM8.6,6.724a4.482,4.482,0,1,1,8.965,0v3.362H8.6Zm5.6,12.015v2.553a1.121,1.121,0,1,1-2.241,0V18.739a2.241,2.241,0,1,1,2.241,0Z",
    transform: "translate(-3)",
    fill: "#a3a3a3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCandadoGris, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/candado_gris.d20bbe44.svg";
export { ForwardRef as ReactComponent };